module.exports = __webpack_public_path__ + "assets/img/icon (5).a77341e9.png";